import { FC } from 'react'

import styled from 'styled-components'

import { variables } from 'src/Styled/variables'
import Waiting from 'src/Assets/Svg/common/waiting.svg?react'

const InfoText = styled.span`
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  max-width: 400px;
`

export const RunningNoReviewsInfoContent: FC = () => (
  <>
    <Waiting />
    <InfoText>
      Your track is now available to curators! Once a curator listens and leaves
      feedback, you&apos;ll be notified by email. You can also view their
      feedback here. This may take a few days, so please be patient.
    </InfoText>
  </>
)
